import InfoIcon from '@mui/icons-material/Info';
import { Box, Card, CardContent, Grid, Stack, Typography } from '@mui/material';

export interface InfoProps {
  infoHeader?: string;
  infoText?: string;
}
export const InfoBox = (props: InfoProps) => {
  const { infoHeader, infoText } = props;

  return (
    <Box
      sx={{
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgb(241,241,241)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Grid
          container
          sx={{
            maxWidth: '1200px',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <Stack
            direction="row"
            justifyContent="flex-start"
            width="100%"
            height="100%"
          >
            <Card sx={{ width: '100%' }}>
              <CardContent>
                <Typography variant="h4" component="h2" color="secondary">
                  {infoHeader ? (
                    <Stack direction="row" alignItems="center">
                      <InfoIcon
                        fontSize="large"
                        style={{
                          paddingRight: 10,
                          verticalAlign: 'bottom',
                        }}
                      />
                      {infoHeader}
                    </Stack>
                  ) : null}
                </Typography>
                {infoText ? <p>{infoText}</p> : null}
              </CardContent>
            </Card>
          </Stack>
        </Grid>
      </Box>
    </Box>
  );
};

InfoBox.defaultProps = {
  infoHeader: '',
  infoText: '',
};
